import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=5c908aee&scoped=true"
import script from "./client-list.vue?vue&type=script&lang=js"
export * from "./client-list.vue?vue&type=script&lang=js"
import style0 from "./client-list.vue?vue&type=style&index=0&id=5c908aee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c908aee",
  null
  
)

export default component.exports